export default "__VITE_ASSET__4SW4OwGU__"